import Image from 'next/image';
import Link from 'next/link';
import { imageEntryToPrismicFormat } from 'remote-com-shared/domains/contentful/prismicBridge';
import styled from 'styled-components';

const BannerWrapper = styled.div``;

export function ImageBanner({ entry, context }) {
  const { link } = entry;

  const {
    banner: { backgroundImage },
  } = context;

  if (!backgroundImage) {
    return null;
  }

  const { dimensions, url } = imageEntryToPrismicFormat(backgroundImage);

  return (
    <BannerWrapper>
      {link ? (
        <Link href={link}>
          <a>
            <Image {...dimensions} src={url} />
          </a>
        </Link>
      ) : (
        <Image {...dimensions} src={url} />
      )}
    </BannerWrapper>
  );
}
